function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.571 2c1.724 0 3.156 1.23 3.489 2.857H18c1.182 0 2.143.961 2.143 2.143S19.182 9.143 18 9.143h0v10.714C18 21.04 17.039 22 15.857 22h0-8.571c-1.182 0-2.143-.961-2.143-2.143h0V9.143C3.96 9.143 3 8.182 3 7s.961-2.143 2.143-2.143h2.93C8.403 3.23 9.846 2 11.57 2zm5 7.143h-10v10.714c0 .394.32.714.715.714h8.571c.394 0 .714-.32.714-.714h0V9.143zM9.43 11.286c.394 0 .714.32.714.714h0v7.143c0 .395-.32.714-.714.714-.395 0-.715-.32-.715-.714h0V12c0-.395.32-.714.715-.714zm4.285 0c.395 0 .715.32.715.714h0v7.143c0 .395-.32.714-.715.714-.395 0-.714-.32-.714-.714h0V12c0-.395.32-.714.714-.714zm4.286-5H5.143c-.394 0-.714.32-.714.714 0 .394.32.714.714.714H18c.394 0 .714-.32.714-.714 0-.394-.32-.714-.714-.714h0zm-6.429-2.857c-.93 0-1.725.597-2.02 1.428h4.041c-.295-.831-1.09-1.428-2.02-1.428z",
  transform: "translate(-32 -331) translate(0 120) translate(16 85) translate(16.5 126)"
}))))));

var SvgIconSil = function SvgIconSil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-sil.3b84fc61.svg";
export { ForwardRef as ReactComponent };